import AppLayout from "../AppLayout";
import { RowDataProvider } from "../contexts/RowDataContext";
import LandingPage from "../pages/LandingPage/LandingPage";
import DeepLinkInitializer from "../pages/LandingPage/components/deep-link/DeepLinkInitializer";
import SetupRenderer from "../pages/LandingPage/components/setup/SetupRenderer";

const DeepLinkRoute = (): JSX.Element => {
  return (
    <RowDataProvider>
      <AppLayout>
        <DeepLinkInitializer>
          <SetupRenderer>
            <LandingPage />
          </SetupRenderer>
        </DeepLinkInitializer>
      </AppLayout>
    </RowDataProvider>
  );
};

export default DeepLinkRoute;
